import { render, staticRenderFns } from "./WorkShiftsPage.vue?vue&type=template&id=717b5736&"
import script from "./WorkShiftsPage.vue?vue&type=script&lang=js&"
export * from "./WorkShiftsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports